import { render, staticRenderFns } from "./mySampleReturnVue.vue?vue&type=template&id=ca141fa2&scoped=true&"
import script from "./mySampleReturnVue.vue?vue&type=script&lang=js&"
export * from "./mySampleReturnVue.vue?vue&type=script&lang=js&"
import style0 from "./mySampleReturnVue.vue?vue&type=style&index=0&id=ca141fa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca141fa2",
  null
  
)

export default component.exports